import type {SearchCriteriaRaw} from '../../../types';
import {createFileFormatFamilyRule} from '../fileFormatFamilyRule';
import type {FileFormatFamilyRule, TSearchTypeFileFormatFamily} from '../types';

export type RawFileFormatFamilySearchCriteria =
	SearchCriteriaRaw<TSearchTypeFileFormatFamily>;

export const rawFileFormatFamilyCriteriaToRuleObject = (
	criteria: RawFileFormatFamilySearchCriteria,
): FileFormatFamilyRule => {
	return createFileFormatFamilyRule({
		fileFormatFamily: criteria.value1,
	});
};

export default rawFileFormatFamilyCriteriaToRuleObject;
